import * as React from 'react';

const CheckCircle16 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M11.746 6.513a.75.75 0 1 0-1.094-1.026L7.45 8.903 5.746 7.087a.75.75 0 1 0-1.094 1.026l2.25 2.4a.75.75 0 0 0 1.094 0z"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-1.5 0a6.5 6.5 0 1 0-13 0 6.5 6.5 0 0 0 13 0"
  }
));
CheckCircle16.Size = 16;
CheckCircle16.Title = "CheckCircle";

export { CheckCircle16 as default };
